import { useBreakpointHelpers } from '../useBreakpointHelpers';
import { styles } from './useResponsiveStyles.styles';
import type { MobileStyles } from './useResponsiveStyles.types';

export const useResponsiveStyles = (): MobileStyles => {
  const { currentBreakpoint } = useBreakpointHelpers();
  const { mobileDirection, mobileAlignment, mobileTextAlignment } = styles;
  const { desktopDirection, desktopAlignment, desktopTextAlignment } = styles;

  return currentBreakpoint.isMobile
    ? {
        direction: mobileDirection,
        alignment: mobileAlignment,
        textAlignment: mobileTextAlignment,
      }
    : {
        direction: desktopDirection,
        alignment: desktopAlignment,
        textAlignment: desktopTextAlignment,
      };
};
